import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
import { ThemeProvider } from './providers/ThemeProvider';
import { SupabaseProvider } from './providers/SupabaseProvider';
import { NotificationProvider } from './providers/NotificationProvider';
import { ServiceWorkerUpdateProvider } from './providers/ServiceWorkerUpdateProvider';
import { AppVersionProvider } from './providers/AppVersionProvider';
import { Loader2 } from 'lucide-react';
import { AddToHomeScreenPrompt } from './components/pwa/AddToHomeScreenPrompt';
import { AppUpdateBanner } from './components/pwa/AppUpdateBanner';

function App() {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    // Simulate initialization time
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-t dark:from-gray-900 dark:to-gray-900 flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <SupabaseProvider>
        <AppVersionProvider>
          <ThemeProvider>
            <NotificationProvider>
              <ServiceWorkerUpdateProvider>
                <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-t dark:from-gray-900 dark:to-gray-900 text-gray-900 dark:text-gray-100">
                  <AppUpdateBanner />
                  <AddToHomeScreenPrompt />
                  <AppRoutes />
                </div>
              </ServiceWorkerUpdateProvider>
            </NotificationProvider>
          </ThemeProvider>
        </AppVersionProvider>
      </SupabaseProvider>
    </BrowserRouter>
  );
}

export default App;
